export const columns = [
  'Project name',
  'Invoice id',
  'Amount',
  'Debt',
  'Paid',
  'Invoice sent',
  'Due date',
  'Paid on',
  'Overdue',
];

export enum InvoiceState {
  OVERDUE = 'OVERDUE',
  PAIDAFTERDUE = 'PAIDAFTERDUE',
  PAID = 'PAID',
  OPEN = 'OPEN',
  ALL = 'ALL',
}

export const InvoiceStateLabel = {
  [InvoiceState.OVERDUE]: 'Overdue',
  [InvoiceState.PAIDAFTERDUE]: 'Paid after due',
  [InvoiceState.OPEN]: 'Open',
  [InvoiceState.PAID]: 'Paid',
  [InvoiceState.ALL]: 'All',
};
